// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"d24713fd","113":"610e23a1","119":"4d41fc62","142":"d1116427","219":"00582346","438":"af552cfb"}[chunkId] + ".chunk.js";
};